<template>
    <div class="flex flex-col h-full">
        <!-- Header -->
        <PinsShowHeader
            v-model="searchInput"
            :sort-value="sortInput"
            @update:sort-value="($event) => sortInput = $event"
            @update:model-value="($event) => searchInput = $event"
        />
        <!-- Body -->
        <ShadowScrollContainer>
            <PinsShowBody v-model="searchInput" :sort-value="sortInput" />
        </ShadowScrollContainer>
        <!-- Footer -->
        <PinsShowFooter/>
    </div>
</template>

<script setup>
import {PinsShowHeader, PinsShowBody, PinsShowFooter} from "@/Components/Modules/Dialogs/Pins/Components";
import {ref} from "vue";
import {ShadowScrollContainer} from "@/Components";

const searchInput = ref('');
const sortInput = ref({
    label: "Name (desc)",
    value: {
        field: "name",
        direction: "desc"
    }}
);
</script>
